import * as _ from 'lodash';

import { first, mergeMap, shareReplay } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LookupMetadata } from '../models/lookup-metadata';
import { ApiClientService } from '../../api-client';

@Injectable({
  providedIn: 'root'
})
export class LookupMetadataService {
  private data$: Observable<LookupMetadata[]>;

  constructor(private apiClientService: ApiClientService) {
    this.data$ = this.getLookupMetadata().pipe(shareReplay(1));
  }

  private getLookupMetadata(): Observable<LookupMetadata[]> {
    return this.apiClientService.get<LookupMetadata[]>('/core/lookups');
  }

  public getLookupMetadataByName(lookupName: string): Observable<LookupMetadata> {
    return this.data$
      .pipe(
        mergeMap((processArray, num) => {
          return processArray.filter(x => this.makeCanonical(x.name) === this.makeCanonical(lookupName));
        }),
        first()
      );
  }

  private makeCanonical(lookupName: string): string {
    return _.replace(lookupName, new RegExp(/\s/g), '').toLowerCase();
  }
}
